module.exports = __webpack_public_path__ + "img/logo-core.b9abc941.svg";